var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6359 79.0491H7.42969C5.81172 79.0491 4.5 80.3608 4.5 81.9788V87.1729C4.5 87.7122 4.9373 88.1495 5.47656 88.1495H94.5269C95.0662 88.1495 95.5035 87.7122 95.5035 87.1729V81.9788C95.5035 80.3608 94.1918 79.0491 92.5738 79.0491H19.6672",
    stroke: "#012060",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9982 51.7482C51.6735 51.7482 53.0316 50.3901 53.0316 48.7148C53.0316 47.0395 51.6735 45.6814 49.9982 45.6814C48.3229 45.6814 46.9648 47.0395 46.9648 48.7148C46.9648 50.3901 48.3229 51.7482 49.9982 51.7482Z",
    stroke: "#012060",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0998 48.7146V48.5171C59.0998 48.2523 59.2072 47.9988 59.3975 47.8148L61.2506 46.023C61.7053 45.5833 61.8026 44.8906 61.4862 44.3427L59.5289 40.9529C59.2127 40.405 58.5641 40.1429 57.9561 40.3167L55.4795 41.0251C55.2248 41.098 54.9514 41.0642 54.7219 40.9316L54.377 40.732C54.1481 40.5996 53.9826 40.38 53.9186 40.1236L53.294 37.625C53.1406 37.0113 52.5891 36.5808 51.9567 36.5808H48.0424C47.4098 36.5808 46.8584 37.0113 46.7051 37.625L46.0805 40.1236C46.0164 40.38 45.851 40.5996 45.6221 40.732L45.2772 40.9316C45.0479 41.0642 44.7744 41.098 44.5195 41.0251L42.043 40.3167C41.4348 40.1427 40.7863 40.405 40.4701 40.9529L38.5129 44.3427C38.1967 44.8906 38.2938 45.5833 38.7485 46.023L40.6016 47.8148C40.792 47.9988 40.8994 48.2523 40.8992 48.5171V48.7146V48.9121C40.8992 49.1769 40.7918 49.4304 40.6016 49.6144L38.7485 51.4062C38.2938 51.8459 38.1965 52.5386 38.5129 53.0865L40.4701 56.4763C40.7863 57.0242 41.435 57.2863 42.043 57.1125L44.5195 56.4041C44.7742 56.3312 45.0477 56.365 45.2772 56.4976L45.6221 56.6972C45.851 56.8296 46.0164 57.0492 46.0805 57.3056L46.7051 59.8042C46.8584 60.4179 47.41 60.8484 48.0424 60.8484H51.9567C52.5893 60.8484 53.1406 60.4179 53.294 59.8042L53.9186 57.3056C53.9826 57.0492 54.1481 56.8296 54.377 56.6972L54.7219 56.4976C54.9512 56.365 55.2246 56.3312 55.4795 56.4041L57.9561 57.1125C58.5643 57.2865 59.2127 57.0242 59.5289 56.4763L61.4862 53.0865C61.8024 52.5386 61.7053 51.8459 61.2506 51.4062L59.3975 49.6144C59.2071 49.4304 59.0996 49.1769 59.0998 48.9121V48.7146Z",
    stroke: "#012060",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50 30.514V24.447",
    stroke: "#012060",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9648 27.4806L49.9982 24.447L53.0316 27.4806",
    stroke: "#012060",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1992 48.7146H86.4",
    stroke: "#012060",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3672 45.6814L86.4006 48.7148L83.3672 51.7484",
    stroke: "#012060",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7982 48.7146H13.5977",
    stroke: "#012060",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6311 45.6814L13.5977 48.7148L16.6311 51.7484",
    stroke: "#012060",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4688 67.0105V79.0492",
    stroke: "#012060",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4688 29.5281V59.9792",
    stroke: "#012060",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.53125 79.0492V29.5281",
    stroke: "#012060",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7818 18.5393L49.4932 11.9176C49.8258 11.8286 50.1762 11.8286 50.5088 11.9176L97.8078 24.5924C98.3311 24.7327 98.6416 25.2704 98.5016 25.7936L97.4332 29.7862C97.2932 30.3096 96.7551 30.6204 96.2316 30.4801L50.2549 18.1612C50.0885 18.1167 49.9135 18.1167 49.7471 18.1612L3.76836 30.4801C3.24492 30.6204 2.70684 30.3096 2.5668 29.7862L1.49844 25.7936C1.3584 25.2704 1.66895 24.7327 2.19219 24.5924L18.1023 20.3291",
    stroke: "#012060",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M50 66.9153V72.9821",
    stroke: "#012060",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9648 69.949L49.9982 72.9824L53.0316 69.949",
    stroke: "#012060",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExt);
export default __webpack_public_path__ + "static/media/ext.26c9481adab6a5d21fb027f37ca16903.svg";
export { ForwardRef as ReactComponent };